// extracted by mini-css-extract-plugin
export var pillWrapper = "_ll-0";
export var showOverflow = "_ll-1";